<div
  class="background"
  fxFlex="100"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <div class="login-container" fxLayout="column" fxLayoutAlign="center center">
    <div
      fxFlex="85"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="25px"
    >
      <div class="bgLogo">
        <img alt="Logo Kuehne+Nagel" src="assets/images/kn_white.png" height="680" width="3389"/>
      </div>
      <div>
        <h2 class="accent-color">{{ 'general.appName' | translate }}</h2>
        <h3 class="accent-color">{{ 'authentication.loginTitle' | translate }}</h3>
      </div>
      <div class="wrapperForm">
        <form
          [formGroup]="loginForm"
          fxLayout="column"
          (keyup)="enterSubmit($event)"
        >
          <mat-form-field appearance="outline">
            <mat-label>{{ 'authentication.loginLabel' | translate }} </mat-label>
            <input formControlName="login" matInput name="email"/>
            @if(loginForm.get('login')?.errors?.['required']){
              <mat-error>
                {{ 'authentication.loginRequired' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'authentication.passwordLabel' | translate }} </mat-label>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              matInput
              name="password"
              required
            />
            <button
              type="button"
              (click)="togglePasswordVisibility()"
              mat-icon-button
              matSuffix
            >
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (loginForm.get('password')?.errors?.['required']) {
              <mat-error>
                {{"authentication.error.passwordIsRequired" | translate}}
              </mat-error>
            }

          </mat-form-field>
        </form>
      </div>
      <button
        (click)="login()"
        [disabled]="!loginForm.valid || processingRequest"
        class="button login"
        mat-flat-button>
        {{
          processingRequest
            ? ('authentication.processing' | translate)
            : ('authentication.loginButton' | translate)
        }}
      </button>
<!--      <button-->
<!--      mat-flat-button-->
<!--      class="button login"-->
<!--      (click)="loginBySSO()"-->
<!--    >-->
<!--      Login por SSO-->
<!--    </button>-->
    </div>
  </div>
</div>
